export const BASE_URL = "https://trial.eway-crm.com/38002";
